import React from "react";
import styles from "./page-positioner.module.scss";
import classNames from "classnames";

type Props = {
  children: React.ReactNode;
  width?: "medium" | "large";
};

const PagePositioner = ({ children, width = "large" }: Props) => {
  const getWidth = () => {
    switch (width) {
      case "medium":
        return styles.medium;
      case "large":
        return styles.large;
    }
  };

  return <div className={classNames(styles.positionerContainer, getWidth())}>{children}</div>;
};

export default PagePositioner;
